import axios from 'axios';
// const API_BASE_URL = 'http://localhost:8000';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
// const API_BASE_URL = 'https://ews-gcs-api-258557095482.us-central1.run.app';
// const API_BASE_URL = 'https://ews-gcs-api4-258557095482.us-central1.run.app';
// const API_BASE_URL = 'https://ews-gcs-api5-258557095482.us-central1.run.app'; 
// const API_BASE_URL = 'https://ews-gcs-api6-258557095482.us-central1.run.app'

// const API_BASE_URL = 'https://ews-gcs-api9-258557095482.us-central1.run.app';
const API_BASE_URL = 'https://ews-gcs-api10-258557095482.us-central1.run.app'




// Upload a file for analysis
export const uploadFile = async (file, configChoice, modelConfig) => {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('config_choice', configChoice);
  formData.append('config', JSON.stringify(modelConfig));
  try {
    const response = await axios.post(`${API_BASE_URL}/upload-and-analyze/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

// Check job status
export const checkJobStatus = async (jobId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/status/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Error checking job status:', error);
    throw error;
  }
};

// Get job results
export const getJobResults = async (jobId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/result/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting job results:', error);
    throw error;
  }
};

// Check CSV availability
export const checkCsvAvailability = async (jobId) => {
  try {
    // The API already returns CSV availability as part of the results call
    const response = await axios.get(`${API_BASE_URL}/result/${jobId}`);
    return {
      has_csv_export: response.data.has_csv_export || false,
      csv_url: response.data.csv_url || null
    };
  } catch (error) {
    console.error('Error checking CSV availability:', error);
    throw error;
  }
};

// Get available configurations
export const getAvailableConfigs = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/available-configs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching available configs:', error);
    throw error;
  }
};

// Get specific configuration
export const getConfig = async (configName) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/config/${configName}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${configName} configuration:`, error);
    throw error;
  }
};